import HeaderPopoverModule from './header-popover.module'

export default HeaderPopoverModule
